import React from 'react'
import { Link } from "react-router-dom";
import HomeMDMessage from '../home/HomeMDMessage';
import HomeAbout from '../home/HomeAbout';
import Accreditations from '../home/Accreditations';
import ChooseUs from '../home/ChooseUs';
import HomeWorkingProcess from '../home/HomeWorkingProcess';
import HomeTestimonials from '../home/HomeTestimonials';


const About = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title"> About Us</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">About Us</li>
                    </ul>
                </div>
            </div>

            <HomeMDMessage />
            <HomeAbout />
            <Accreditations />
            <ChooseUs />
            <HomeWorkingProcess />
            <HomeTestimonials />


        </>
    )
}

export default About